//@ts-ignore
if (typeof window !== 'undefined') {
  /**
   * Canvas context protoype overload to handle drawing curves
  */
  //@ts-ignore
  CanvasRenderingContext2D.prototype.curve = function (
    points,
    tension,
    numOfSeg,
    close,
  ) {
    tension = typeof tension === 'number' ? tension : 0.5
    numOfSeg = numOfSeg ? numOfSeg : 20

    var pts,
      res = [],
      l = points.length,
      i,
      cache = new Float32Array((numOfSeg + 2) * 4),
      cachePtr = 4

    pts = points.slice(0)

    if (close) {
      pts.unshift(points[l - 1])
      pts.unshift(points[l - 2])
      pts.push(points[0], points[1])
    } else {
      pts.unshift(points[1])
      pts.unshift(points[0])
      pts.push(points[l - 2], points[l - 1])
    }

    cache[0] = 1

    for (i = 1; i < numOfSeg; i++) {
      var st = i / numOfSeg,
        st2 = st * st,
        st3 = st2 * st,
        st23 = st3 * 2,
        st32 = st2 * 3

      cache[cachePtr++] = st23 - st32 + 1
      cache[cachePtr++] = st32 - st23
      cache[cachePtr++] = st3 - 2 * st2 + st
      cache[cachePtr++] = st3 - st2
    }

    cache[++cachePtr] = 1

    parse(pts, cache, l)

    if (close) {
      pts = []
      pts.push(points[l - 4], points[l - 3], points[l - 2], points[l - 1])
      pts.push(points[0], points[1], points[2], points[3])
      parse(pts, cache, 4)
    }

    function parse(pts, cache, l) {
      for (var i = 2; i < l; i += 2) {
        var pt1 = pts[i],
          pt2 = pts[i + 1],
          pt3 = pts[i + 2],
          pt4 = pts[i + 3],
          t1x = (pt3 - pts[i - 2]) * tension,
          t1y = (pt4 - pts[i - 1]) * tension,
          t2x = (pts[i + 4] - pt1) * tension,
          t2y = (pts[i + 5] - pt2) * tension

        for (var t = 0; t <= numOfSeg; t++) {
          var c = t * 4

          res.push(
            cache[c] * pt1 +
              cache[c + 1] * pt3 +
              cache[c + 2] * t1x +
              cache[c + 3] * t2x,
            cache[c] * pt2 +
              cache[c + 1] * pt4 +
              cache[c + 2] * t1y +
              cache[c + 3] * t2y,
          )
        }
      }
    }

    for (i = 0, l = res.length; i < l; i += 2) this.lineTo(res[i], res[i + 1])

    return res
  }
}
